import { Form, Input, Select, Skeleton } from 'antd'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { HelpDrawer } from '../Generics/help-drawer'
import { UtilsContext } from '@BUP/contexts/utils-context'
import styles from './form-inputs.module.scss'
import AddElementsInput from './add-elements-input'

export const ComplaintFormInputs = ({ form }) => {
  const i18n = useTranslation()
  const { data, isLoading } = useContext(UtilsContext)
  const [infractionType, setInfractionType] = useState(null)
  const [openWhereAndWhen, setOpenWhereAndWhen] = useState(false)
  const [openDescription, setOpenDescription] = useState(false)

  return (
    <Skeleton active loading={isLoading}>
      <div className={styles.inputs_wrapper}>
        <Form.Item
          name='title'
          label={i18n.t('common.resources.complaint.attributes.title.label')}
          rules={[{ required: true, message: i18n.t('common.resources.complaint.attributes.title.validations.required') }]}
          style={{ display: 'inline-block', width: '48%' }}
        >
          <Input maxLength={130} />
        </Form.Item>
        <AddElementsInput
          form={form}
          inputName='complainants'
          inputLabel={i18n.t('common.resources.complaint.attributes.complainants.label')}
          requiredMessage={i18n.t('common.resources.complaint.attributes.complainant.validations.required')}
          placeholder={i18n.t('common.resources.complaint.attributes.involved-people.placeholder')}
          tagColor='#17bebb'
        />
      </div>
      <div className={styles.inputs_wrapper}>
        <Form.Item
          name='infractionType'
          label={i18n.t('common.resources.complaint.attributes.infraction-type.label')}
          rules={[{ required: true, message: i18n.t('common.resources.complaint.attributes.infraction-type.validations.required') }]}
          style={{ display: 'inline-block', width: '48%' }}
        >
          {data && (
            <Select
              options={data.complaint.infractionTypes.map(infractionType => ({ value: infractionType, label: i18n.t(`common.resources.complaint.values.infraction-type.${infractionType}.label`) }))}
              onChange={(value) => setInfractionType(value)}
            />
          )}
        </Form.Item>
        {infractionType === 'cit007' && (
          <Form.Item
            name='infractionTypeOtherDescription'
            label={i18n.t('common.resources.complaint.attributes.infraction-type-other-description.label')}
            rules={[{ required: true, message: i18n.t('common.resources.complaint.attributes.infraction-type-other-description.validations.required') }]}
            style={{ display: 'block', width: '48%' }}
          >
            <Input />
          </Form.Item>
        )}
        <Form.Item
          name='infractionLevel'
          label={i18n.t('common.resources.complaint.attributes.infraction-level.label')}
          rules={[{ required: true, message: i18n.t('common.resources.complaint.attributes.infraction-level.validations.required') }]}
          style={{ display: 'inline-block', width: '48%' }}
        >
          {data && (
            <Select
              options={data.complaint.infractionLevels.map(infractionLevel => ({ value: infractionLevel, label: i18n.t(`common.resources.complaint.values.infraction-level.${infractionLevel}.label`) }))}
            />
          )}
        </Form.Item>
      </div>
      <div className={styles.inputs_wrapper}>
        <AddElementsInput
          form={form}
          inputName='involvedPeople'
          inputLabel={i18n.t('common.resources.complaint.attributes.involved-people.label')}
          requiredMessage={i18n.t('common.resources.complaint.attributes.involved-people.validations.required')}
          placeholder={i18n.t('common.resources.complaint.attributes.involved-people.placeholder')}
          tagColor='#ff8577'
        />
        <AddElementsInput
          form={form}
          inputName='involvedCourses'
          inputLabel={i18n.t('common.resources.complaint.attributes.involved-courses.label')}
          requiredMessage={i18n.t('common.resources.complaint.attributes.involved-courses.validations.required')}
          placeholder={i18n.t('common.resources.complaint.attributes.involved-courses.placeholder')}
          tagColor='#6441a5'
        />
      </div>
      <Form.Item
        name='whereAndWhen'
        label={i18n.t('common.resources.complaint.attributes.description.events_time.label')}
        rules={[{ required: true, message: i18n.t('common.resources.complaint.attributes.description.events_time.validations.required') }]}
        tooltip={{ open: false, onClick: () => setOpenWhereAndWhen(true) }}
      >
        <Input.TextArea style={{ fontFamily: 'monospace' }} autoSize={{ minRows: 10, maxRows: 30 }} />
      </Form.Item>
      <div data-testid='complaint-events-time-tooltip'>
        <HelpDrawer prefix='common.resources.complaint.attributes.description.events_time' title={i18n.t('common.resources.complaint.attributes.description.events_time.label')} open={openWhereAndWhen} onClose={() => setOpenWhereAndWhen(false)} />
      </div>

      <Form.Item
        name='description'
        label={i18n.t('common.resources.complaint.attributes.description.detailed_description.label')}
        rules={[{ required: true, message: i18n.t('common.resources.complaint.attributes.description.detailed_description.validations.required') }]}
        tooltip={{ open: false, onClick: () => setOpenDescription(true) }}
      >
        <Input.TextArea style={{ fontFamily: 'monospace' }} autoSize={{ minRows: 10, maxRows: 30 }} />
      </Form.Item>
      <div data-testid='complaint-description-tooltip'>
        <HelpDrawer prefix='common.resources.complaint.attributes.description.detailed_description' title={i18n.t('common.resources.complaint.attributes.description.detailed_description.label')} open={openDescription} onClose={() => setOpenDescription(false)} />
      </div>
    </Skeleton>
  )
}
